export const VARIABLES = {
    FORM_TYPE_PDE: 2,
    FORM_TYPE_MAES: 1,
};
export const SUBMISSION_TYPE = {
    TYPE_PDE: 3,
    TYPE_MAES: 2
}
export const STEP_MENU = {
    STEP_DATOS_GENERALES: '1',
    STEP_HOJA_VIDA: '2',
    STEP_CARTA_PRESENTACION: '3',
    STEP_DOCUMENTACION: '4'
};
export const TYPE_FORM = {
    INF_ACADEMIC_PREGRADO: '1',
    INF_ACADEMIC_POSTGRADO: '2',
    INF_ACADEMIC_OTHERS: '3',
}